import { render, staticRenderFns } from "./MyCommissionV2.vue?vue&type=template&id=090ea96c&scoped=true"
import script from "./MyCommissionV2.vue?vue&type=script&lang=js"
export * from "./MyCommissionV2.vue?vue&type=script&lang=js"
import style0 from "./MyCommissionV2.vue?vue&type=style&index=0&id=090ea96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ea96c",
  null
  
)

export default component.exports